import {
  EMPTY_STRING,
  globalConstants,
  STORE_BILLING_STATUS,
} from "../../constants";

const isStripeSubscriptionActive = (billing) => {
  const storeBilling = billing?.billing || billing || {};
  return (
    storeBilling.storeBillingStatus === STORE_BILLING_STATUS.ACTIVE_SUBSCRIPTION
  );
};

const getAllStoreIds = (companyStores = []) => {
  return companyStores?.map((store) => store.id).join(",") || EMPTY_STRING;
};

const createCompanyStoreOptions = (companyStores) => {
  const storeOptions = companyStores.map((store) => ({
    label: store.storeName,
    value: store.id,
  }));
  return [
    companyStores.length > 1 && {
      label: globalConstants.ALL_STORES,
      value: getAllStoreIds(companyStores),
    },
    ...storeOptions,
  ].filter(Boolean);
};

export {
  isStripeSubscriptionActive,
  createCompanyStoreOptions,
  getAllStoreIds,
};
